// extracted by mini-css-extract-plugin
export default {"error":"multiple-products-selection-error__error___n7msS"};